export const normalizeAustralianMobile = (value: string): string => value.replace(/\D/g, '')

export const formatAustralianMobileInput = (value: string): string => {
  const digits = normalizeAustralianMobile(value).slice(0, 10)

  if (digits.length <= 4) {
    return digits
  }

  if (digits.length <= 7) {
    return `${digits.slice(0, 4)} ${digits.slice(4)}`
  }

  return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`
}

export const isValidAustralianMobile = (value: string): boolean =>
  /^04\d{8}$/.test(normalizeAustralianMobile(value))

export const createLocalApplicationPersonId = (prefix: string): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `${prefix}-${crypto.randomUUID()}`
  }

  return `${prefix}-${Date.now()}-${Math.round(Math.random() * 100000)}`
}
